import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatSuggestionsForm } from './SuggestionsTable/contexts/vatSuggestionsFormContext'

interface VatSuggestionsActionsProps {
  onSkipClick: () => void
}

export const VatSuggestionsActions = ({ onSkipClick }: VatSuggestionsActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { submitForm, reviewedRowIds } = useVatSuggestionsForm()

  const handleApproveClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  const hasReviewedSuggestions = reviewedRowIds.size > 0

  return (
    <ButtonsGroup>
      <Button variant="outlined" onClick={onSkipClick}>
        {t('skip')}
      </Button>
      <Button onClick={handleApproveClick} disabled={!hasReviewedSuggestions}>
        {t('confirm')}
      </Button>
    </ButtonsGroup>
  )
}
